// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"3903b695","239":"ef1698d9","368":"a1c340db","455":"7e58f213","977":"8980fa5d"}[chunkId] + ".chunk.js";
};